(async () => {
const {
  getElement,
  store,
  useState,
  useEffect,
} = await import("@wordpress/interactivity");

const useScroll = () => {
  const documentElement = document.documentElement;
  const [ scroll, setScroll ] = useState( {
    top: window.pageYOffset || documentElement.scrollTop,
    direction: null,
  } );

  useEffect( () => {
    const onScroll = function() {
      const scrollTop = window.pageYOffset || documentElement.scrollTop;

      // Updates from the previous state. The listener itself must not
      // read `scroll` because that closure holds the first render's
      // state forever, and then an upward scroll is never detected.
      setScroll(( previous ) => {
        let { top, direction } = previous;

        if (scrollTop > top && direction !== "bottom") {
          direction = "bottom";
        } else if (scrollTop < top) {
          direction = "top";
        }

        top = scrollTop <= 0 ? 0 : scrollTop; // for Mobile or negative scrolling
        return {
          top,
          direction,
        };
      });
    };

    window.addEventListener("scroll", onScroll, false);
    return () => window.removeEventListener("scroll", onScroll, false);
  }, []);

  return scroll;
}

store("parts/header", {
  // Automatically reacts to state changes.
  callbacks: {
    scroll() {
      if (CSS.supports(`container-type: scroll-state`)) {
        return;
      }

      const scroll = useScroll();
      useEffect( () => {
        // Add scroll direction classes to header.
        const { ref } = getElement();
        const classList = ref.classList;
        classList.toggle("@scroll-direction-none",  !scroll.direction);
        classList.toggle("@scroll-direction-top", scroll.direction === "top");
        classList.toggle("@scroll-direction-bottom", scroll.direction === "bottom");

        const styles = window.getComputedStyle(ref);
        if (styles.position === "sticky" || styles.position === "-webkit-sticky") {
          const boundingRect = ref.getBoundingClientRect();
          classList.toggle("@scroll-stuck-top", scroll.top > boundingRect.top);
        }
      });
    }
  },
});
})();